import ModelUtil from '@leverege/model-util';
import StringUtil from '@leverege/string-util';
const imagineType = 'filters';
const TYPE = `aggregation.${imagineType}`;
function create() {
  return {
    type: TYPE,
    filters: []
  };
}
function getValueType(model) {
  return 'buckets';
}
function formatBucketKey(bucket, value, options) {
  return bucket.key;
}
export default {
  create,
  TYPE,
  name: StringUtil.camelCaseToTitleCase(imagineType),
  ...ModelUtil.createAllArray('filters'),
  getValueType,
  toImagineAgg: model => {
    if (model.filters == null || model.filters.length === 0) {
      return null;
    }
    const filters = model.filters.reduce((prev, value) => {
      if (value?.filter?.filter) {
        prev[value.name] = value.filter.filter;
      }
      return prev;
    }, {});
    if (Object.keys(filters).length > 0) {
      return {
        type: 'filters',
        filters
      };
    }
    return null;
  },
  formatBucketKey
};